module.exports = __webpack_public_path__ + "img/game_main_pc_277_off.b7244a47.png";